<header>
    <h1>
        <img src="/img/poll_ninja_logo.svg" alt="Poll Ninja Logo">
    </h1>
</header>

<style>
    header{
        background-color: #f7f7f7;
        padding: 20px;
    }

    h1{
        margin: 0;
        text-align: center;
    }

    img{
        max-width: 180px;
    }
</style>